/* istanbul ignore file */
import React from 'react';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useShowContext } from 'framework/show';
import { useServiceCatalogId } from 'domain/organization/serviceCatalog/useServiceCatalogId';
import ServiceCatalogBreadcrumbs from 'domain/organization/serviceCatalog/shared/ServiceCatalogBreadcrumbs';
import { useServiceCatalogUrl } from 'domain/shared/serviceCatalog';

const SingleServiceCatalogBreadcrumbs = ({ children }: { children?: React.ReactNode }) => {
  const { data } = useShowContext();
  const { getSingleEntityUrl } = useServiceCatalogUrl();
  const id = useServiceCatalogId();
  const serviceName = data?.getValueBySource('name') ?? 'Service';

  return (
    <ServiceCatalogBreadcrumbs>
      <SingleBreadcrumbItem entity={serviceName} link={getSingleEntityUrl(id)} />
      {children}
    </ServiceCatalogBreadcrumbs>
  );
};

export default SingleServiceCatalogBreadcrumbs;
